<template>
  <span
    class="ui-nav-icon-wrap"
    :class="{ 'ui-nav-icon-wrap--premium': premium }"
  >
    <span v-if="premium" class="ui-nav-icon__shell" aria-hidden="true">
      <span class="ui-nav-icon__core">
        <svg
          class="ui-nav-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          v-html="markup"
        />
      </span>
    </span>
    <svg
      v-else
      class="ui-nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      v-html="markup"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { NAV_ICONS, type NavIconId, isNavIconId } from '../consts/navIcons';

const props = withDefaults(
  defineProps<{
    /** 预设图标 id；无 svg 时生效 */
    name?: NavIconId | string;
    /** 自定义 SVG 内部 markup（path/g 等），优先于 name — 站点可自带图标而不改组件库 */
    svg?: string;
    premium?: boolean;
  }>(),
  {
    name: 'home',
    premium: false
  }
);

const markup = computed(() => {
  const custom = props.svg?.trim();
  if (custom) return custom;
  if (props.name && isNavIconId(props.name)) return NAV_ICONS[props.name];
  return NAV_ICONS.home;
});
</script>
